import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Tambah Setting Invoice Product")
  ])
], -1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sekolah", -1)
const _hoisted_10 = ["label", "value"]
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "col-lg-6 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Pilih Tipe", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Tipe", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", {
  value: "Registration",
  key: "Registration"
}, " Registration ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: "Migration",
  key: "Migration"
}, "Migration", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", {
  value: "Order",
  key: "Order"
}, "Order", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  value: "Custom App",
  key: "Custom App"
}, "Custom App", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "Monthly Fee",
  key: "Monthly Fee"
}, " Monthly Fee ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  value: "Package",
  key: "Package"
}, "Package", -1)
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-6 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Setting", -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Diskon", -1)
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-6 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Produk", -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-lg-6 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Due Date", -1)
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-6 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Default Price", -1)
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "col-lg-6 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Diskon", -1)
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-6 fv-row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Pajak", -1)
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-6 fv-row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Exp Date", -1)
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_62 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveChanges1())),
          "validation-schema": _ctx.addSettingValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "schoolId",
                    modelValue: _ctx.onlyId.schoolId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyId.schoolId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listSchool, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option._id,
                          label: option.name,
                          value: option._id
                        }, null, 8, _hoisted_10))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "schoolId" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-control form-control-lg form-control-solid",
                    name: "tipe",
                    placeholder: "Isi Tipe",
                    autocomplete: "off",
                    modelValue: _ctx.onlyId.tipe,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.onlyId.tipe) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_ErrorMessage, { name: "tipe" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "title",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Setting",
                    modelValue: _ctx.addSetting.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addSetting.title) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_ErrorMessage, { name: "" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "customPrice.title",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Diskon",
                    modelValue: _ctx.addSetting.customPrice.title,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addSetting.customPrice.title) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "title" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "item",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Produk",
                    modelValue: _ctx.addSetting.item,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addSetting.item) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_ErrorMessage, { name: "item" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "dueDate",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Exp Date",
                    modelValue: _ctx.addSetting.customPrice.dueDate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addSetting.customPrice.dueDate) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_ErrorMessage, { name: "dueDate" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "defaultPrice",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Pajak",
                    modelValue: _ctx.addSetting.defaultPrice,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addSetting.defaultPrice) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_ErrorMessage, { name: "defaultPrice" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "discount",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Diskon",
                    modelValue: _ctx.addSetting.customPrice.discount,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addSetting.customPrice.discount) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_ErrorMessage, { name: "discount" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "tax",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Pajak",
                    modelValue: _ctx.addSetting.tax,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addSetting.tax) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_ErrorMessage, { name: "tax" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "expiredInDays",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Exp Date",
                    modelValue: _ctx.addSetting.expiredInDays,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addSetting.expiredInDays) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_ErrorMessage, { name: "expiredInDays" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/superadmin/setting-invoices')))
              }, " Batal "),
              _createElementVNode("button", _hoisted_62, _hoisted_65, 512)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ])
  ], 64))
}